if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        // Appstle (and similar apps) render selling_plan inputs outside the product <form>.
        appendSellingPlan(formData, sticky) {
          const root = sticky
            ? document.querySelector('.product-info')
            : (this.$el.closest('.product-info') || document.querySelector('.product-info'));
          if (!root || !formData) return;

          // Prefer Appstle's active frequency select when Subscribe & Save is selected.
          const activeOption = root.querySelector('.appstle-active-option');
          if (activeOption) {
            const appstleSelect = activeOption.querySelector('select.appstle_select');
            if (appstleSelect && appstleSelect.value) {
              formData.set('selling_plan', appstleSelect.value);
              return;
            }
          }

          const checkedRadio = root.querySelector('input[name="selling_plan"]:checked');
          if (checkedRadio) {
            formData.set('selling_plan', checkedRadio.value);
            return;
          }

          const select = root.querySelector('select[name="selling_plan"]');
          if (select) {
            formData.set('selling_plan', select.value);
          }
        },
        async addToCart(e, required, quickView, sticky) {
          this.loading = true;         
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            await Alpine.store('xCartHelper').waitForCartUpdate();
            window.updatingCart = true;

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);
            this.appendSellingPlan(formData, sticky);

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');
            const linkedProductListQty = newFormData.getAll('properties[_linked_product_id_qty][]');
            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) || 
              (linkedProductList.length > 0) ||
              (linkedProductListQty.length > 0)
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductListQty.length > 0) {
                let qty = newFormData.get('quantity');
                linkedProductListQty.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: qty,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              
              if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) {
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                additionalOptionData.forEach((item, index) => {
                  const base = `items[${index}]`;

                  newFormData.append(`${base}[id]`, item.id);
                  newFormData.append(`${base}[quantity]`, item.quantity);

                  if (item.parent_id) {
                    newFormData.append(`${base}[parent_id]`, item.parent_id);
                  }

                  if (item.properties) {
                    Object.entries(item.properties).forEach(([key, value]) => {
                      newFormData.append(`${base}[properties][${key}]`, value);
                    })
                  }
                })
              }
            }

            let resProductId;

            await fetch(`${Eurus.cart_add_url}`, {
              method:'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            }).then(reponse => {
              return reponse.json();
            }).then(async (response) => {
              if (response.status == '422') {
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              } else {  
                resProductId = response.product_id;

                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};
      
                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();
                document.dispatchEvent(new CustomEvent("eurus:video-popup:close-popup"));
                if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  Alpine.store('xCartHelper').reRenderSections(response.sections);
                  if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                    Alpine.store('xMiniCart').openCart();
                  }               
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
                  if (Alpine.store('xQuickView')) {
                    Alpine.store('xQuickView').openPopupMobile = false;
                  }
                  this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                  this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                  document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                }
              }
            }).catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              window.updatingCart = false;
              document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${resProductId}`));
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            })
          }, 0)
        }
      }))
    });

    // Keep ATC button price in sync with Appstle Subscribe & Save selection.
    const syncAppstleAtcPrice = () => {
      const dataEl = document.querySelector('[id^="selling-plan-price-data-"]');
      const root = document.querySelector('.product-info');
      if (!dataEl || !root || !window.Alpine?.store('xHelper')?.formatMoney) return;

      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      const activeOption = root.querySelector('.appstle-active-option');
      let planId = '';
      if (activeOption) {
        const appstleSelect = activeOption.querySelector('select.appstle_select');
        if (appstleSelect?.value) planId = String(appstleSelect.value);
      }
      if (!planId) {
        const checkedRadio = root.querySelector('input[name="selling_plan"]:checked');
        planId = checkedRadio?.value ? String(checkedRadio.value) : '';
      }

      const variantId = String(
        root.querySelector('input[name="id"]')?.value
        || document.querySelector(`#update-variant-${data.sectionId}`)?.value
        || ''
      );
      const variantData = data.variants?.[variantId];
      if (!variantData) return;

      let unitPrice = variantData.price;
      let unitCompare = variantData.compare_at_price || variantData.price;
      if (planId && variantData.selling_plans?.[planId]) {
        unitPrice = variantData.selling_plans[planId].price;
        unitCompare = variantData.selling_plans[planId].compare_at_price || variantData.price;
      }

      const scope = document.querySelector(`.x-product-${data.sectionId}`) || document;
      scope.querySelectorAll('.add_to_cart_button .target-price').forEach((el) => {
        el.textContent = unitPrice;
      });
      scope.querySelectorAll('.add_to_cart_button .target-compare-at-price').forEach((el) => {
        el.textContent = unitCompare;
      });

      const qtyInput = root.querySelector('input[name="quantity"]')
        || document.getElementById(`Quantity-atc-${data.sectionId}`);
      const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
      const formattedPrice = Alpine.store('xHelper').formatMoney(unitPrice * qty, data.moneyFormat);
      const formattedCompare = Alpine.store('xHelper').formatMoney(unitCompare * qty, data.moneyFormat);

      scope.querySelectorAll('.add_to_cart_button .main-product-price .price, .add_to_cart_button .main-product-price .price-sale').forEach((el) => {
        el.innerHTML = formattedPrice;
      });
      scope.querySelectorAll('.add_to_cart_button .main-product-price .price-compare').forEach((el) => {
        el.innerHTML = formattedCompare;
      });
    };

    const scheduleAppstleAtcPriceSync = () => {
      setTimeout(syncAppstleAtcPrice, 50);
    };

    [
      'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
      'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
      'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
      'AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated',
      'AppstleSubscription:SubscriptionWidget:widgetInitialised',
    ].forEach((eventName) => {
      document.addEventListener(eventName, scheduleAppstleAtcPriceSync);
    });

    document.addEventListener('change', (event) => {
      if (
        event.target.matches?.(
          'input[name="selling_plan"], select.appstle_select, select[name="selling_plan"], input[name="id"], input[name="quantity"]'
        )
      ) {
        scheduleAppstleAtcPriceSync();
      }
    });

    // Also catch Appstle clicks that may not fire change reliably.
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('.appstle_subscription_wrapper')) {
        scheduleAppstleAtcPriceSync();
      }
    });

    document.addEventListener('alpine:initialized', scheduleAppstleAtcPriceSync);
    // Appstle often mounts after first paint; retry a few times.
    [300, 800, 1500, 2500].forEach((delay) => setTimeout(syncAppstleAtcPrice, delay));

    // Re-apply after variant HTML swap.
    const sellingPlanDataEl = document.querySelector('[id^="selling-plan-price-data-"]');
    if (sellingPlanDataEl) {
      try {
        const { sectionId } = JSON.parse(sellingPlanDataEl.textContent);
        if (sectionId) {
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, scheduleAppstleAtcPriceSync);
          document.addEventListener(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, scheduleAppstleAtcPriceSync);
        }
      } catch (e) {}
    }
  });
}
